// extracted by mini-css-extract-plugin
module.exports = {"podContent":"ConsignmentPod_podContent__BK8hL","pageInfo":"ConsignmentPod_pageInfo__32aUE","buttonNavigation":"ConsignmentPod_buttonNavigation__3Ugzc"};